import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  errorTranslate,
  azilisSwitchToBool,
} from "../util";

// ============================================
// Flow 33.1: Manufacturing Processes (LCA)
// ============================================

export const getAllManufacturingProcesses33_1LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-processes-33-1-lca",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects((response.data?.data || []).map((d) => d));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const addManufacturingProcesses33_1LCA = ({
  productId,
  process,
  qty,
  row_order,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const data = JSON.stringify({
    process: process || null, // code
    qty: qty || 0,
    ...(row_order !== undefined ? { row_order } : {}),
  });

  const config = {
    method: "post",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-processes-33-1-lca",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function () {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      setErrorMessage(error.response?.data);
    });
};

export const updateManufacturingProcesses33_1LCA = ({
  productId,
  rowId,
  process,
  qty,
  row_order,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
}) => {
  const data = JSON.stringify({
    process: process || null, // code
    qty: qty || 0,
    ...(row_order !== undefined ? { row_order } : {}),
  });

  const config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-processes-33-1-lca/" +
      rowId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      const updated = response.data?.data;
      if (updated && Array.isArray(objects)) {
        setObjects(
          objects.map((row) => (row.id === updated.id ? updated : row))
        );
      }
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
    });
};

export const deleteManufacturingProcesses33_1LCA = ({
  productId,
  rowId,
  callback = null,
  loading = null,
  setLoading = null,
}) => {
  const config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-processes-33-1-lca/" +
      rowId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function () {
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
    });
};

// ============================================
// Flow 33.2: By-products / Surplus Resources (LCA)
// ============================================

export const getAllManufacturingByProducts33_2LCA = ({
  productId,
  setObjects = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-by-products-33-2-lca",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects((response.data?.data || []).map((d) => d));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const addManufacturingByProducts33_2LCA = ({
  productId,
  surplus_resource,
  qty,
  by_product_sold,
  by_product_used_in_this_product,
  by_product_used_in_another_product,
  monetary_value,
  currency,
  row_order,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  const data = JSON.stringify({
    surplus_resource: surplus_resource || null, // code
    qty: qty || 0,
    by_product_sold: azilisSwitchToBool(by_product_sold),
    by_product_used_in_this_product: azilisSwitchToBool(
      by_product_used_in_this_product
    ),
    by_product_used_in_another_product: azilisSwitchToBool(
      by_product_used_in_another_product
    ),
    monetary_value: monetary_value || null,
    currency: currency || null, // currency code (e.g. "EUR")
    ...(row_order !== undefined ? { row_order } : {}),
  });

  const config = {
    method: "post",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-by-products-33-2-lca",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data,
  };

  if (loading) setLoading("load");

  axios(config)
    .then(function () {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      setErrorMessage(error.response?.data);
    });
};

export const updateManufacturingByProducts33_2LCA = ({
  productId,
  rowId,
  surplus_resource,
  qty,
  by_product_sold,
  by_product_used_in_this_product,
  by_product_used_in_another_product,
  monetary_value,
  currency,
  row_order,
  objects,
  setObjects = function () {
    return;
  },
}) => {
  const data = JSON.stringify({
    surplus_resource: surplus_resource || null,
    qty: qty || 0,
    by_product_sold: azilisSwitchToBool(by_product_sold),
    by_product_used_in_this_product: azilisSwitchToBool(
      by_product_used_in_this_product
    ),
    by_product_used_in_another_product: azilisSwitchToBool(
      by_product_used_in_another_product
    ),
    monetary_value: monetary_value || null,
    currency: currency || null,
    ...(row_order !== undefined ? { row_order } : {}),
  });

  const config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-by-products-33-2-lca/" +
      rowId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data,
  };

  axios(config)
    .then(function (response) {
      const updated = response.data?.data;
      if (updated && Array.isArray(objects)) {
        setObjects(objects.map((r) => (r.id === updated.id ? updated : r)));
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteManufacturingByProducts33_2LCA = ({
  productId,
  rowId,
  callback = null,
}) => {
  const config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/manufacturing-by-products-33-2-lca/" +
      rowId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function () {
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
    });
};
